(() => {
  const init = () => {
    document.querySelectorAll('[data-bf-clock]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const initialPhase = root.dataset.phase.trim();
      const dates = ['start','public','end'].map(key => Date.parse(root.dataset[key]));
      if (dates.some(value => !Number.isFinite(value))) return;
      const phaseAt = now => now >= dates[2] ? 'ended' : now >= dates[1] ? 'public' : now >= dates[0] ? 'vip' : 'upcoming';
      const clock = root.querySelector('[data-bf-time]');
      const tick = () => {
        if (!root.isConnected) return;
        const now = Date.now();
        const phase = phaseAt(now);
        if (phase !== initialPhase && !window.Shopify?.designMode) { window.location.reload(); return; }
        if (clock) {
          const target = dates[1];
          const seconds = Math.max(0,Math.floor((target-now)/1000));
          const values = [Math.floor(seconds/86400),Math.floor(seconds/3600)%24,Math.floor(seconds/60)%60,seconds%60];
          clock.replaceChildren(...values.map((n,i) => {
            const unit = document.createElement('span');
            unit.textContent = String(n).padStart(2,'0');
            const label = document.createElement('small');
            label.textContent = ['J','H','MIN','S'][i];
            unit.append(label);
            return unit;
          }));
        }
        window.setTimeout(tick,1000);
      };
      tick();
    });
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();

(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s/g,'').replace(/,/g,'.').replace(/(\d+(?:\.\d+)?)kg/g,(_,n) => `${Number(n)*1000}g`);
  const init = () => document.querySelectorAll('[data-bf-purchase-mode="abo"]').forEach(card => {
    if (card.dataset.subscriptionReady) return;
    const form = card.querySelector('.card__add-form');
    const plan = form?.querySelector('[data-bf-selling-plan]');
    if (!plan) return;
    card.dataset.subscriptionReady = 'true';
    const select = card.querySelector('[data-bf-subscription-variant]');
    const button = form.querySelector('button[type="submit"]');
    const syncPlan = () => {
      if (select) plan.value = select.selectedOptions[0]?.dataset.bfPlan || '';
      button.disabled = !plan.value || (select && (!select.value || select.selectedOptions[0]?.disabled));
      if (select && !card.querySelector('[data-bf-preview-data]')) {
        const selected = select.selectedOptions[0];
        const price = card.querySelector('[data-bf-price]');
        const compare = card.querySelector('[data-bf-compare]');
        if (price && selected) price.textContent = selected.dataset.bfPrice;
        if (compare && selected) compare.textContent = selected.dataset.bfCompare;
      }
    };
    if (select) {
      const options = [...select.options];
      const tokens = option => {
        try { return JSON.parse(option.dataset.bfOptions).map(normalize); } catch { return []; }
      };
      const filterFormat = label => {
        const format = normalize(label);
        const previous = select.selectedOptions[0];
        const previousTokens = previous ? tokens(previous) : [];
        options.forEach(option => {
          const matches = !format || tokens(option).includes(format);
          option.hidden = !matches;
          option.disabled = !matches || option.dataset.bfAvailable !== 'true' || !option.dataset.bfPlan;
        });
        if (!previous || previous.disabled) {
          const available = options.filter(option => !option.disabled);
          const sameFlavor = available.find(option => tokens(option).some(token => token !== format && previousTokens.includes(token)));
          select.value = (sameFlavor || available[0])?.value || '';
        }
        syncPlan();
      };
      select.addEventListener('change',syncPlan);
      card.addEventListener('bf:format-change',event => filterFormat(event.detail.label));
      let formats;
      try { formats = JSON.parse(card.querySelector('[data-bf-preview-data]')?.textContent || '[]'); } catch { formats = []; }
      const hasFormatOptions = formats.some(format => options.some(option => tokens(option).includes(normalize(format.label))));
      filterFormat(hasFormatOptions ? formats[0]?.label || '' : '');
    } else syncPlan();
    form.addEventListener('submit',event => {
      syncPlan();
      if (button.disabled) event.preventDefault();
    });
  });
  init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('click',event => {
    const link = event.target.closest('[data-bf-subscribe-target]');
    if (!link || !link.hash) return;
    const form = document.getElementById(link.hash.slice(1))?.querySelector('.card__add-form');
    const button = form?.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    event.preventDefault();
    form.requestSubmit(button);
  });
})();

(() => {
  const pending = new WeakSet();
  document.addEventListener('submit',async event => {
    const form = event.target;
    if (!form.matches('.yam-bf form.card__add-form') || event.defaultPrevented) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.getSectionsToRender || !drawer.renderContents) return;
    event.preventDefault();
    if (pending.has(form)) return;
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (button?.disabled) return;
    const body = new FormData(form);
    body.delete('return_to');
    const sections = drawer.getSectionsToRender().map(section => section.id);
    body.set('sections',sections.join(','));
    body.set('sections_url',window.location.pathname);
    let message = form.querySelector('[data-bf-cart-error]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'small';
      message.dataset.bfCartError = '';
      message.setAttribute('role','alert');
      form.append(message);
    }
    message.hidden = true;
    pending.add(form);
    form.setAttribute('aria-busy','true');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy','true');
    }
    drawer.setActiveElement?.(button || document.activeElement);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{
        method:'POST',
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
        body
      });
      const state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(typeof state.description === 'string' ? state.description : window.cartStrings.error);
      }
      if (sections.some(id => !state.sections?.[id])) {
        const refreshed = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${encodeURIComponent(sections.join(','))}`,{headers:{Accept:'application/json'}});
        if (!refreshed.ok) throw new Error(window.cartStrings.error);
        state.sections = await refreshed.json();
      }
      if (sections.some(id => !state.sections?.[id])) throw new Error(window.cartStrings.error);
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{
          source:'yam-bf',productVariantId:body.get('id'),cartData:state
        })).catch(() => {});
      }
    } catch (error) {
      message.textContent = error.message || window.cartStrings.error;
      message.hidden = false;
    } finally {
      pending.delete(form);
      form.removeAttribute('aria-busy');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
})();

(() => {
  const init = () => document.querySelectorAll('[data-bf-section-nav]').forEach(nav => {
    if (nav.dataset.scrollReady) return;
    nav.dataset.scrollReady = 'true';
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const sections = links.map(link => document.getElementById(link.hash.slice(1)));
    const header = document.querySelector('.section-header');
    let pending = false;
    const update = () => {
      pending = false;
      if (!nav.isConnected) return;
      const headerBottom = Math.max(0,header?.getBoundingClientRect().bottom || 0);
      const offset = matchMedia('(min-width: 990px)').matches ? Math.min(headerBottom,innerHeight/2) : 0;
      const height = nav.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--bf-sticky-top',`${offset}px`);
      document.documentElement.style.setProperty('--bf-nav-height',`${height}px`);
      const marker = offset + (matchMedia('(min-width: 990px)').matches ? height : 0) + 24;
      let active = -1;
      sections.forEach((section,i) => {
        if (!section) return;
        const bounds = section.getBoundingClientRect();
        if (bounds.top <= marker && bounds.bottom > marker) active = i;
      });
      links.forEach((link,i) => {
        if (i === active) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    const observer = new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
    update();
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();

document.addEventListener('change',event => {
  if (!event.target.matches('[data-bf-variant]')) return;
  const selected = event.target.selectedOptions[0];
  const card = event.target.closest('[data-bf-card]');
  if (!selected || !card) return;
  const price = card.querySelector('[data-bf-price]');
  if (price) price.textContent = selected.dataset.price;
  card.querySelectorAll('[data-bf-product-link]').forEach(link => {link.href = selected.dataset.url;});
  const compare = card.querySelector('[data-bf-compare]');
  if (compare) {compare.textContent = selected.dataset.compare;compare.hidden = !selected.dataset.compare;}
  const discount = card.querySelector('[data-bf-discount]');
  if (discount) {discount.textContent = selected.dataset.discount;discount.hidden = !selected.dataset.discount;}
});

(() => {
  const init = () => document.querySelectorAll('[data-bf-preview-variants]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-bf-preview-data]').textContent); } catch { return; }
    if (!Array.isArray(variants) || variants.length < 2) return;
    const card = root.closest('[data-bf-card]');
    const group = document.createElement('div');
    group.className = 'sizes';
    group.setAttribute('role','group');
    group.setAttribute('aria-label','Format');
    const format = value => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(value);
    const update = index => {
      const variant = variants[index];
      group.querySelectorAll('button').forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
      const price = card.querySelector('[data-bf-price]');
      const compare = card.querySelector('[data-bf-compare]');
      const badge = card.querySelector('[data-bf-discount]');
      if (price) price.textContent = format(variant.now) + (root.dataset.priceSuffix || '');
      if (compare) compare.textContent = format(variant.was);
      if (badge) badge.textContent = variant.badge;
      const packPrice = card.querySelector('[data-bf-pack-price]');
      const saving = card.querySelector('[data-bf-saving]');
      if (packPrice) packPrice.textContent = format(variant.now);
      if (saving) saving.textContent = format(variant.was - variant.now);
      const packCompare = card.querySelector('[data-bf-pack-compare]');
      if (packCompare) packCompare.textContent = format(variant.was);
      card.querySelectorAll('[data-bf-item]').forEach((line,i) => {
        const item = variant.items?.[i];
        if (!item) return;
        const cells = line.querySelectorAll('span');
        cells[0].textContent = item[0];
        cells[1].textContent = item[1] == null ? '' : format(item[1]);
      });
      card.dispatchEvent(new CustomEvent('bf:format-change',{detail:{label:variant.label}}));
    };
    variants.forEach((variant,index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = variant.label;
      button.setAttribute('aria-pressed',String(index === 0));
      button.addEventListener('click',() => update(index));
      group.append(button);
    });
    root.append(group);
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();

(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s/g,'');
  const init = () => document.querySelectorAll('[data-bf-purchase-mode="collab"]').forEach(card => {
    if (card.dataset.cartVariantsReady) return;
    const select = card.querySelector('select[name="id"]');
    const button = card.querySelector('.card__add-form button[type="submit"]');
    if (!select || !button) return;
    card.dataset.cartVariantsReady = 'true';
    const tokens = option => { try { return JSON.parse(option.dataset.bfOptions).map(normalize); } catch { return []; } };
    const sync = () => { button.disabled = !select.value || select.selectedOptions[0]?.disabled; };
    const filter = label => {
      const format = normalize(label);
      const previous = select.selectedOptions[0];
      const previousTokens = previous ? tokens(previous) : [];
      const options = [...select.options];
      options.forEach(option => {
        const matches = !format || tokens(option).includes(format);
        option.hidden = !matches;
        option.disabled = !matches || option.dataset.bfAvailable !== 'true';
      });
      if (!previous || previous.disabled) {
        const available = options.filter(option => !option.disabled);
        select.value = (available.find(option => tokens(option).some(token => token !== format && previousTokens.includes(token))) || available[0])?.value || '';
      }
      sync();
    };
    select.addEventListener('change',sync);
    card.addEventListener('bf:format-change',event => filter(event.detail.label));
    filter(card.querySelector('.sizes button[aria-pressed="true"]')?.textContent || '');
    card.querySelector('.card__add-form').addEventListener('submit',event => { sync(); if (button.disabled) event.preventDefault(); });
  });
  init();
  document.addEventListener('shopify:section:load',init);
})();
